export default class Queue {
    constructor() {
        this.q = [];
    }

    add(func) {
        if(typeof func !== 'function') {
            console.error('%c<queue add> not function:', 'color:gray;', func);
            return false;
        }

        this.q.push(func);
    }

    run(param) {
        if( !this.q.length ) {
           return false;
        }

        for(var i = 0; i < this.q.length; i++) {
            this.q[i](param);
        }
    }

	clear() {
		if( !this.q.length ) {
			return false;
		}

		this.q = [];
	}
}


// WEBPACK FOOTER //
// ./src/common/js/queue.js